<mat-accordion class="sg-ui-component" [displayMode]="'flat'" [multi]="multi">
  @for (item of items; track i; let i = $index) {
    <mat-expansion-panel [expanded]="allExpanded || (expandedPanelIndexes && expandedPanelIndexes.includes(i))" class="mat-elevation-z0 sg-ui-component">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">{{ item[titleProperty] }}</mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: item }"></ng-container>
    </mat-expansion-panel>
  }
</mat-accordion>
